<section class="pago-section">
  <div class="pago-container">
    <div class="pago-header">
      <h1 class="pago-title">Pago</h1>
      <p class="pago-subtitle">Introduce el concepto y el importe a pagar</p>
    </div>

    <form [formGroup]="form" novalidate>
      <!-- Concepto + Importe -->
      <div class="pago-card">
        <h2 class="pago-card__title">Detalle del pago</h2>

        <div class="pago-field">
          <label for="pl-concept"
            >Concepto <span class="required">*</span></label
          >
          <input
            pInputText
            id="pl-concept"
            formControlName="concept"
            placeholder="Ej: Factura #2025-001 / Dominio .com"
            autocomplete="off"
            [class.ng-invalid]="
              formSubmitted && form.get('concept')?.invalid
            " />
          @if (formSubmitted && form.get('concept')?.hasError('required')) {
            <small class="pago-field__error">Campo obligatorio</small>
          }
          @if (formSubmitted && form.get('concept')?.hasError('maxlength')) {
            <small class="pago-field__error">Máximo 200 caracteres</small>
          }
        </div>

        <div class="pago-field">
          <label for="pl-amount"
            >Importe (€) <span class="required">*</span></label
          >
          <p-inputNumber
            id="pl-amount"
            formControlName="amount"
            mode="decimal"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [min]="0.01"
            placeholder="0,00"
            suffix=" €"
            [class.ng-invalid]="formSubmitted && form.get('amount')?.invalid"
            styleClass="w-full" />
          @if (formSubmitted && form.get('amount')?.hasError('required')) {
            <small class="pago-field__error">Campo obligatorio</small>
          }
          @if (formSubmitted && form.get('amount')?.hasError('min')) {
            <small class="pago-field__error"
              >El importe debe ser mayor que 0</small
            >
          }
        </div>

        @if (amountValue > 0) {
          <p-divider />
          <div class="pago-card__row pago-card__row--total">
            <span class="pago-card__label">Total</span>
            <span class="pago-card__total">{{ amountFormatted }}</span>
          </div>
        }
      </div>

      <!-- Datos del pagador -->
      <div class="pago-card mt-4">
        <h2 class="pago-card__title">Tus datos</h2>

        <div class="pago-field">
          <label for="pl-name"
            >Nombre completo / Empresa <span class="required">*</span></label
          >
          <input
            pInputText
            id="pl-name"
            formControlName="name"
            placeholder="Juan García López / Construcciones García S.L."
            autocomplete="name"
            [class.ng-invalid]="formSubmitted && form.get('name')?.invalid" />
          @if (formSubmitted && form.get('name')?.hasError('required')) {
            <small class="pago-field__error">Campo obligatorio</small>
          }
        </div>

        <div class="pago-field">
          <label for="pl-email">Email <span class="required">*</span></label>
          <input
            pInputText
            id="pl-email"
            formControlName="email"
            type="email"
            placeholder="juan@ejemplo.com"
            autocomplete="email"
            [class.ng-invalid]="formSubmitted && form.get('email')?.invalid" />
          @if (formSubmitted && form.get('email')?.hasError('required')) {
            <small class="pago-field__error">Campo obligatorio</small>
          }
          @if (formSubmitted && form.get('email')?.hasError('email')) {
            <small class="pago-field__error">Email no válido</small>
          }
        </div>

        <div class="pago-field">
          <label for="pl-phone">Teléfono</label>
          <input
            pInputText
            id="pl-phone"
            formControlName="phone"
            type="tel"
            placeholder="+34 600 000 000"
            autocomplete="tel" />
        </div>
      </div>

      <!-- Error -->
      @if (errorMsg) {
        <div class="pago-error">{{ errorMsg }}</div>
      }

      <!-- Botones de pago -->
      <div class="pago-actions mt-4">
        <p-button
          label="Pagar con tarjeta"
          icon="pi pi-credit-card"
          [loading]="loading"
          [disabled]="loadingBizum"
          styleClass="w-full"
          (onClick)="pay(false)" />

        @if (activateBizum) {
          <p-button
            label="Pagar con Bizum"
            icon="pi pi-mobile"
            severity="secondary"
            [loading]="loadingBizum"
            [disabled]="loading"
            styleClass="w-full"
            (onClick)="pay(true)" />
        }
      </div>

      <p class="pago-note">
        <i class="pi pi-lock" aria-hidden="true"></i>
        Pago seguro · Redsys · Verifactu
      </p>
    </form>

    <!-- Formulario oculto hacia Redsys -->
    <form #redsysForm method="POST" [action]="tpvUrl" style="display: none">
      <input
        type="hidden"
        name="Ds_SignatureVersion"
        [value]="Ds_SignatureVersion" />
      <input
        type="hidden"
        name="Ds_MerchantParameters"
        [value]="Ds_MerchantParameters" />
      <input type="hidden" name="Ds_Signature" [value]="Ds_Signature" />
    </form>
  </div>
</section>
